import { RestApiResponse } from '../../common/rest-api.response';

import { UserInfo } from './user-info';

export class UserGetInfoResponse extends RestApiResponse {
    public userInfo: UserInfo;

    constructor(data?: Partial<UserGetInfoResponse>) {
        super(data);
        this.userInfo = data && new UserInfo(data.userInfo);
    }
}
